import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { EmailVerifyBanner } from "./EmailVerifyBanner";

/**
 * Top-level operator-app frame: sidebar + (topbar + email-verify banner +
 * content). Wrap any route that should render inside the Booqly chrome
 * with this. Auth pages and the onboarding wizard opt out by rendering
 * outside `<AppShell>`.
 */
export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="grid grid-cols-[240px_1fr] min-h-screen">
      <Sidebar />
      <div className="flex flex-col min-w-0">
        <TopBar />
        <EmailVerifyBanner />
        <main className="flex-1">{children}</main>
      </div>
    </div>
  );
}
